import './App.css';
import Pages from './components/pages/Pages';
import { CartProvider } from './components/context/CartContext';
import InstantQuoteWidget from './other/InstantQuoteWidget';



function App() {
  return (
    <div className="App">
      <CartProvider>        
   <Pages /></CartProvider>

    </div>
  );
}

export default App;
